import React from 'react'
import type { ChangeEvent, PropsWithChildren } from 'react'

import { useMatomo } from '@jonkoops/matomo-tracker-react'
import type { Location } from 'history'
import { useLocation } from 'react-router-dom'

import { trackEventFiltered } from '../UserTracker/UserTracker'

export type MatamoWrapperProps = PropsWithChildren<{
  id?: string
  eventType: string
  onChange?: (e: ChangeEvent<any>) => void
  trackEventTrigger?: 'onChange' | 'onBlur'
  style?: React.CSSProperties
}>

// track event when onChange event is triggered by default because this is the current behaviour
const MatomoWrapper = ({ id, children, eventType, trackEventTrigger = 'onChange', style }: MatamoWrapperProps) => {
  const { trackEvent } = useMatomo()
  // Yes, this is insane but there's no good way to mock `useLocation` with react-router v5
  let location: Location
  try {
    location = useLocation() as Location
  } catch {
    // no-op
    // without this jest goes boom
  }

  const handleTrack = () => {
    if ('Cypress' in window) {
      return
    }
    trackEventFiltered(trackEvent, location, eventType, id)
  }

  return (
    <div
      onChange={trackEventTrigger === 'onChange' ? handleTrack : undefined}
      onBlur={trackEventTrigger === 'onBlur' ? handleTrack : undefined}
      style={{ width: '100%', ...style }}
    >
      {children}
    </div>
  )
}

export default MatomoWrapper
